import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { useAuthStore } from '@/store/auth.store';
import {
  loginResponseSchema,
  userProfileSchema,
  type LoginPayload,
  type LoginResponse,
} from '../types/auth.types';

export async function login(payload: LoginPayload): Promise<LoginResponse> {
  const res = await apiClient.post(API.auth.login, payload);
  const parsed = loginResponseSchema.parse(res.data);
  useAuthStore.getState().setAuth(parsed.accessToken, parsed.user);
  return parsed;
}

export async function ssoLogin(token: string): Promise<LoginResponse> {
  const res = await apiClient.post(API.auth.ssoLogin, { token });
  const parsed = loginResponseSchema.parse(res.data);
  useAuthStore.getState().setAuth(parsed.accessToken, parsed.user);
  return parsed;
}

export const authQueryKeys = {
  all: () => ['auth'] as const,
  profile: () => [...authQueryKeys.all(), 'profile'] as const,
};

export const profileQueryOptions = queryOptions({
  queryKey: authQueryKeys.profile(),
  queryFn: async () => {
    const res = await apiClient.get(API.auth.profile);
    return userProfileSchema.parse(res.data);
  },
  staleTime: 0,
});

export async function changePassword(payload: {
  oldPassword: string;
  newPassword: string;
}): Promise<void> {
  await apiClient.patch(API.auth.changePassword, payload);
}

export async function logout(): Promise<void> {
  await apiClient.post(API.auth.logout);
  useAuthStore.getState().clearAuth();
}
